import classNames from "classnames";
import React from "react";

const Dot = ({ color, small }: { color: string | "red" | "yellow" | "green", small?: boolean }) => {
  let hex = color;

  if (color === "red") {
    hex = "#f41f03";
  }

  if (color === "yellow") {
    hex = "#EBBF11";
  }

  if (color === "green") {
    hex = "#17b699";
  }

  const classes = classNames("icon-circle", {
    small
  });

  return (<i className={classes} style={{ color: hex }}></i>);
};

export default Dot;